import { TASK_ITEMS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/task_items_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'taskItemsIndex',
	'checkoutModalFormIndex',
	'woPrintTaskItemIndex',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
